import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import GetEnvironment from "../../environments"

interface ExtensionRemovedMessageProps {
  projectId: string
}

const connectWebUrl = GetEnvironment().connectWebUrl

export const ExtensionRemovedMessage = (props: ExtensionRemovedMessageProps) => {
  const { t } = useTranslation("config")

  useEffect(() => {
    return () => {
      localStorage.setItem("extensionRemoved", "false")
    }
  }, [])

  const handleClick = () => {
    localStorage.setItem("extensionRemoved", "false")
  }

  return (
    <div className="module d-flex h-100 flex-column justify-content-center align-items-center text-center">
      <h1 className="p-3">{t("extensionRemovedMessage.heading")}</h1>
      <p>{t("extensionRemovedMessage.body")}</p>
      <ul>
        <li className="p-2">
          <a
            href={`${connectWebUrl}/projects/${props.projectId}/settings/details`}
            rel="noreferrer"
            target="_blank"
            onClick={handleClick}
          >
            {t("extensionRemovedMessage.projectDetailsLink")}
          </a>
        </li>
        <li className="p-1">
          <a href={`${connectWebUrl}/projects`} rel="noreferrer" target="_blank" onClick={handleClick}>
            {t("extensionRemovedMessage.projectOverviewLink")}
          </a>
        </li>
      </ul>
    </div>
  )
}
